/* @flow */

import React from "react";
import { useTranslate } from "@awardit/react-use-translate";

import styles from "./styles.scss";

const HowToRedeem = ({ locale }: { locale: string }): React$Node => {
  const t = useTranslate();

  const steps = [
    {
      title: t("REDEEM.HOWTO.CODE"),
      imgSrc: `${locale}/code.png`,
    },
    {
      title: t("REDEEM.HOWTO.BALANCE"),
      imgSrc: "common/balance.png",
    },
    {
      title: t("REDEEM.HOWTO.SELECT"),
      imgSrc: "common/select.png",
    },
    {
      title: t("REDEEM.HOWTO.DELIVERY"),
      imgSrc: `${locale}/delivery.png`,
    },
  ];

  return (
    <ul className={styles.list}>
      {steps.map((x, i) => (
        <li key={x.imgSrc} className={styles.item}>
          <img src={`/assets/howtoredeem/${x.imgSrc}`} alt={x.title} />
          <p>{i + 1}. {x.title}</p>
        </li>
      ))}
    </ul>
  );
};

export default HowToRedeem;
